// extracted by mini-css-extract-plugin
export default {"clamp_text":"TextTruncate_clamp_text__BBHKy","is_expanded":"TextTruncate_is_expanded__n4-Zw","clamp_toggle":"TextTruncate_clamp_toggle__DPI5Z"};